import { render, staticRenderFns } from "./ui-message.vue?vue&type=template&id=16afced4&"
import script from "./ui-message.vue?vue&type=script&lang=js&"
export * from "./ui-message.vue?vue&type=script&lang=js&"
import style0 from "./ui-message.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16afced4')) {
      api.createRecord('16afced4', component.options)
    } else {
      api.reload('16afced4', component.options)
    }
    module.hot.accept("./ui-message.vue?vue&type=template&id=16afced4&", function () {
      api.rerender('16afced4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/ui-message.vue"
export default component.exports